import React from "react";
import { Home } from "../Home/Home";
import styles from "./Header.module.css";

function Header({ setHidden, setShowGallery }) {
  return (
    <div id="header" className={styles.container}>
      <Home setHidden={setHidden} setShowGallery={setShowGallery}></Home>
    </div>
  );
}

export { Header };
